var map = {
	"./2dmap/home_page.png": "LSPE",
	"./2dmap_eyes/home_page.png": "H/nT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qd4h";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/home_page\.png$
// module id = qd4h
// module chunks = 2